import Dropdown from './dropdown';
import CostCentreCollection from '../collections/costcentre';

export const CostCentreDropdown = Dropdown.extend({
  template: require('../templates/dropdown.html'),

  constructor() {
    this.collection = new CostCentreCollection(null, {
      urlBase: '/useraccount/',
      search_params: {
        format: 'json'
      }
    });
    Marionette.CompositeView.prototype.constructor.apply(this, arguments);
    this.collection.fetch();
  },

  attribute: 'costcentre'
});



// WEBPACK FOOTER //
// ./transactions/views/costcentre_dropdown.js